<div class="callback-container">
  <div class="callback-content">
    @if (isProcessing()) {
      <div class="processing-state">
        <p-progressSpinner></p-progressSpinner>
        <h2>Processing...</h2>
        <p>Please wait while we verify your card.</p>
      </div>
    } @else if (isSuccess()) {
      <div class="success-state">
        <div class="success-icon">
          <i class="pi pi-check-circle"></i>
        </div>
        <h2>Card Added Successfully!</h2>
        <p>Your debit card has been verified and added to your account.</p>
        <div class="actions">
          <button class="btn-primary" (click)="viewCards()">
            View My Cards
          </button>
        </div>
      </div>
    } @else if (isError()) {
      <div class="error-state">
        <div class="error-icon">
          <i class="pi pi-times-circle"></i>
        </div>
        <h2>Verification Failed</h2>
        <p>{{ errorMessage() || 'Failed to verify your card. Please try again.' }}</p>
        <div class="actions">
          <button class="btn-secondary" (click)="goBack()">
            Go Back
          </button>
        </div>
      </div>
    }
  </div>
</div>

<p-toast></p-toast>
